// src/components/CommentCitationSystem.js
import React, { useState, useEffect } from 'react';
import { addComment, deleteComment, subscribeToComments } from '../firebase/comments';
import CommentForm from './CommentForm';
import CitationForm from './CitationForm';
import CommentTable from './CommentTable';

const CommentCitationSystem = ({ user }) => {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('comment'); // 'comment' or 'citation'
  
  // Subscribe to comments when component mounts
  useEffect(() => {
    let unsubscribe = () => {};
    
    if (user) {
      setIsLoading(true);
      unsubscribe = subscribeToComments((commentsData) => {
        setComments(commentsData);
        setIsLoading(false);
      });
    } else {
      setComments([]);
      setIsLoading(false);
    }
    
    // Cleanup subscription when component unmounts
    return () => unsubscribe();
  }, [user]);
  
  const handleError = (errorMessage) => {
    setError(errorMessage);
  };
  
  if (!user) {
    return (
      <div className="comment-citation-system">
        <div className="sign-in-prompt">
          <p>Please sign in to view and participate in discussions</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="comment-citation-system">
      {error && (
        <div className="error-banner">
          {error}
          <button 
            className="close-button" 
            onClick={() => setError(null)}
          >
            ×
          </button>
        </div>
      )}
      
      <div className="form-tabs">
        <button 
          className={`form-tab ${activeTab === 'comment' ? 'active' : ''}`}
          onClick={() => setActiveTab('comment')}
        >
          Add Comment
        </button>
        <button 
          className={`form-tab ${activeTab === 'citation' ? 'active' : ''}`}
          onClick={() => setActiveTab('citation')}
        >
          Add Citation
        </button>
      </div>
      
      <div className="form-content">
        {activeTab === 'comment' ? (
          <CommentForm 
            user={user} 
            onError={handleError} 
          />
        ) : (
          <CitationForm 
            user={user} 
            onError={handleError} 
          />
        )}
      </div>
      
      <CommentTable 
        comments={comments} 
        isLoading={isLoading}
        user={user}
        onError={handleError}
      />
    </div>
  );
};

export default CommentCitationSystem;